import { InputContainer } from "components/form/inputs/inputs.styled";
import { Text } from "components/Typography/text.styled";
import { ColorV2 } from "config/colors";
import { FontFamily, TypographyV2 } from "config/font";
import styled from "styled-components";

export const NumberInputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-family: ${FontFamily.MontserratBold}, Helvetica;
`;

export const HourlyRateContainer = styled.div`
  display: flex;
  align-center: center;
  margin-top: 10px;
`;

export const FeesContainer = styled.div`
  margin-top: 10px;
  font-family: ${FontFamily.SpaceGroteskMedium}, Helvetica;
  background-color: ${ColorV2.White};
  border-radius: 12px;
  padding: 14px;
  display: inline-block;
  width: 50%;
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    margin: 5px;
  }
`;

export const InfoCircle = styled.div`
  display: flex;
  justify-content: center;
  border: 1.5px solid ${ColorV2.Blue4};
  background-color: transparent;
  border-radius: 999px;
  width: 22px;
  height: 22px;
  align-items: center;
  color: ${ColorV2.Blue4};
  margin: 0 0 0 8px;
  font-family: ${FontFamily.SpaceGroteskBold}, Helvetica;
  font-size: 14px;
  line-height: 1;
  cursor: default;
`;

export const CostRows = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CostRow = styled.div`
  display: grid;
  grid-template-columns: minmax(90px, 1fr) minmax(120px, 1fr);
  align-items: center;
  gap: 12px;
  padding: 10px 0;
`;

export const CostLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue3};
`;

export const CostValue = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  text-align: right;
`;

export const CostDivider = styled.div`
  display: none;
`;

export const CostFootnote = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
  display: inline-block;
  max-width: 260px;
  line-height: 1.2;
  margin-top: 4px;
`;

export const EstimatedCostLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
`;

export const EmptyCostText = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const HourlyRateInputContainer = styled(InputContainer)`
  margin-top: 2%;
`;

export const HourlyRateTopRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 24px;
`;

export const HourlyRateInputsWrapper = styled.div`
  flex: 1;
`;

export const HourlyRateInputsRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
`;

export const MinRateFieldWrapper = styled.div`
  width: 160px;
  margin-right: 1%;

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;

export const MaxRateFieldWrapper = styled.div`
  width: 160px;
  margin-left: 1%;

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;

export const DashText = styled(Text)`
  margin: 0 1% 3%;
`;

export const PaymentMethodWrapper = styled.div`
  width: 280px;
  transform: translateX(-40px);
`;

export const EstimatedCostRow = styled(RowWrapper)`
  justify-content: flex-start;
  margin-top: 2%;
`;

export const ErrorTextWrapper = styled.div`
  margin-top: 8px;
`;
